<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h2>Kostenloser telefonischer Support für die App-Nutzenden</h2>
            </div>
            <div class="right-wrapper">
                <h1>Professioneller Support</h1>
                <p class="text">Das Support-Team steht jederzeit zur Verfügung, um bei der Einrichtung der App zu helfen, Fragen zu beantworten und die Nutzung aller App-Funktionen optimal zu begleiten.</p>
                <p class="text">Durch das Team aus Ernährungsfachkräften (Diätassistenz und Ökotrophologie) ist professionelle Unterstützung rund um die Uhr gewährleistet.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" weiterBtn :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 11
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

